import axios from "axios";
class Kfunc {
  databass = (jsondata) => {
    return new Promise((resolve, reject) => {
      axios
        .post("/database", jsondata, {
          headers: {
            Accept: "application/json",
          },
        })
        .then(function (response) {
          const arrf = response.data;
          // alert(arrf)
          resolve(arrf);
        })
        .catch(function (error) {
          console.log(error);
          reject();
        });
    });
  };

    fetchlocal = (jsondata) => {
    return new Promise((resolve, reject) => {
      axios
        .post("/fetchlocal", jsondata, {
          headers: {
            Accept: "application/json",
          },
        })
        .then(function (response) {
          const arrf = response.data;
          // alert(arrf)
          resolve(arrf);
        })
        .catch(function (error) {
          console.log(error);
          reject();
        });
    });
  };

  fecth = (jsondata) => {
    return new Promise((resolve, reject) => {
        // resolve({status: 200, message: "access_token is issued", access_token: "laK40pcKhgADRbKQgtpefmN5fdbfImxLXCozWtOxlVc"})
        //  resolve({error: 200})
      axios
        .post("/fecth", jsondata, {
          headers: {
            Accept: "application/json",
          },
        })
        .then(function (response) {
          const arrf = response.data;
          // alert(arrf)
          resolve(arrf);
        })
        .catch(function (error) {
          console.log(error);
          
          resolve({ error: error });
        });
    });
  };

  getstatus = (jsondata) => {
    return new Promise((resolve, reject) => {
      axios
        .post("/fecthget", jsondata, {
          headers: {
            Accept: "application/json",
          },
        })
        .then(function (response) {
          const arrf = response.data;
          // alert(arrf)
          resolve(arrf);
        })
        .catch(function (error) {
          console.log(error);
          resolve({ error: error });
        });
    });
  };

  //   fecth = (jsondata) => {
  //     return new Promise((resolve, reject) => {
  //       var config = {
  //         method: "post",
  //         url: '/fecth',
  //         headers: jsondata.headers,
  //         data: jsondata,
  //       };
  //       axios(config)
  //         .then(function (response) {
  //           const data = response.data;
  //           resolve(data);
  //         })
  //         .catch(function (error) {
  //           resolve({ error: error });
  //         });
  //     });
  //   };
}
export default new Kfunc();



// WEBPACK FOOTER //
// src/utill/util.js